import './App.css';

import { lazy, Suspense } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

// כל רוט נטען כצ'אנק נפרד, כך שדף הקורס לא מוריד את הקוד של דף הטיפולים ולהפך
const CourseWrapper = lazy(() => import('./CourseWrapper'));
const TreatsWrapper = lazy(() => import('./TreatsWrapper'));

function App() {
  return <>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/course" element={<CourseWrapper/>}/>
          <Route path="/" element={<TreatsWrapper/>}/>
        </Routes>
      </Suspense>
    </BrowserRouter>
  </>
}

export default App;
